import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck, faXmark } from '@fortawesome/free-solid-svg-icons';

const rows = [
  { feature: 'AI visibility setup', byllms: 'Included', agency: '$500 - $1,500 setup' },
  { feature: 'Monthly optimization', byllms: 'Included', agency: '$1,000 - $3,000' },
  { feature: 'Time to results', byllms: 'Included', agency: '2 - 3 months' },
  { feature: 'Ongoing changes', byllms: 'Included', agency: '$500 - $1,000' },
];

export default function ComparisonTable() {
  return (
    <section className="flex flex-col items-center px-4 md:px-0 w-full">
      <h2 className="font-headline text-[32px] md:text-[40px] leading-[1.2] text-[#1e1c1c] text-center max-w-[640px]">
        Agencies charge thousands. Most of them can't even do this.
      </h2>

      <div className="bg-white border border-[#e5e7eb] w-full max-w-[960px] mt-12 overflow-hidden">
        {/* Header row */}
        <div className="flex border-b border-[#e5e7eb] min-h-[52px] md:min-h-[65px]">
          <div className="w-[140px] md:w-[320px] shrink-0" />
          <div className="flex-1 bg-[rgba(18,161,66,0.1)] flex items-center justify-center py-4 md:py-6">
            <span className="font-body font-semibold text-[12px] md:text-[14px] tracking-[0.7px] uppercase text-[#12a142]">
              By LLMS
            </span>
          </div>
          <div className="flex-1 flex items-center justify-center py-4 md:py-6">
            <span className="font-body font-semibold text-[12px] md:text-[14px] tracking-[0.7px] uppercase text-[#1b1b1b] opacity-50 text-center">
              Agency /<br className="md:hidden" /> Consultant
            </span>
          </div>
        </div>

        {/* Feature rows */}
        {rows.map((row) => (
          <div key={row.feature} className="flex border-b border-[#e5e7eb] min-h-[56px] md:min-h-[72px]">
            <div className="w-[140px] md:w-[320px] shrink-0 px-3 md:px-6 flex items-center">
              <span className="font-body font-medium text-[14px] md:text-[16px] text-[#1b1b1b]">
                {row.feature}
              </span>
            </div>
            <div className="flex-1 bg-[rgba(18,161,66,0.1)] flex items-center justify-center gap-[10px]">
              {row.byllms === 'Included' && (
                <FontAwesomeIcon icon={faCircleCheck} className="text-[#12a142] text-[20px]" />
              )}
              <span className="hidden md:inline font-body font-semibold text-[16px] text-[#00802b]">
                {row.byllms}
              </span>
              {row.byllms !== 'Included' && (
                <span className="md:hidden font-body font-semibold text-[14px] text-[#00802b]">
                  {row.byllms}
                </span>
              )}
            </div>
            <div className="flex-1 flex items-center justify-center">
              <FontAwesomeIcon icon={faXmark} className="text-[#df2427] text-[16px] md:mr-[10px]" />
              <span className="hidden md:inline font-body font-semibold text-[16px] text-[rgba(30,28,28,0.5)]">
                {row.agency}
              </span>
            </div>
          </div>
        ))}

        {/* Cost row */}
        <div className="flex min-h-[56px] md:min-h-[72px]">
          <div className="w-[140px] md:w-[320px] shrink-0 px-3 md:px-6 flex items-center">
            <span className="font-body font-medium text-[14px] md:text-[16px] text-[#1b1b1b]">
              Typical monthly cost
            </span>
          </div>
          <div className="flex-1 bg-[rgba(18,161,66,0.1)] flex items-center justify-center">
            <span className="font-body font-semibold text-[14px] md:text-[16px] text-[#00802b]">
              From $99
            </span>
          </div>
          <div className="flex-1 flex items-center justify-center">
            <span className="font-body font-semibold text-[14px] md:text-[16px] text-[rgba(30,28,28,0.5)]">
              $10,000+ / year
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
